import fetch$1 from 'isomorphic-unfetch';
import cookies from 'js-cookie';

var fetcherPure = function fetcherPure(url, options) {
  try {
    return Promise.resolve(fetch$1(url, options)).then(function (response) {
      return Promise.resolve(response.json()).then(function (body) {
        if (response.status !== 200) {
          throw Error(body.message);
        }

        return body;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NetworkError = function NetworkError(response, data) {
  var _ref = response || {},
      method = _ref.method,
      url = _ref.url,
      status = _ref.status,
      statusText = _ref.statusText;

  this.name = 'NetworkError';
  this.statusText = statusText || null;
  this.status = status || null;
  this.data = data || null;
  this.request = {
    method: method,
    url: url
  };
  this.stack = new Error().stack; // eslint-disable-next-line @typescript-eslint/no-explicit-any
};
NetworkError.prototype = /*#__PURE__*/Object.create(Error.prototype);
var getResponseBody = function getResponseBody(response, // eslint-disable-next-line @typescript-eslint/no-explicit-any
responseDataTransformer) {
  try {
    var _temp3 = function _temp3(_result) {
      return _exit2 ? _result : response.text();
    };

    var _exit2 = false;
    var contentType = response.headers.get('content-type') || '';

    var _temp4 = function () {
      if (contentType.includes('application/json')) {
        return Promise.resolve(response.json()).then(function (json) {
          _exit2 = true;
          return responseDataTransformer ? responseDataTransformer(json) : json;
        });
      }
    }();

    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
  } catch (e) {
    return Promise.reject(e);
  }
};

var methods;

(function (methods) {
  methods["GET"] = "GET";
  methods["PUT"] = "PUT";
  methods["PATCH"] = "PATCH";
  methods["POST"] = "POST";
  methods["DELETE"] = "DELETE";
})(methods || (methods = {}));

var isTokenRefreshing = false;
var failedRequests = [];

var pushToFailedRequests = function pushToFailedRequests(request) {
  return new Promise(function (resolve, reject) {
    failedRequests.push({
      resolve: resolve,
      reject: reject
    });
  }).then(function (token) {
    return request(token);
  }).then(function (response) {
    return getResponseBody(response);
  })["catch"](function (error) {
    return Promise.reject(error);
  });
};

var processQueue = function processQueue(error, token) {
  isTokenRefreshing = false;
  failedRequests.forEach(function (_ref) {
    var reject = _ref.reject,
        resolve = _ref.resolve;
    if (error) reject(error);else resolve(token);
  });
  failedRequests = [];
};

var fetcher = function fetcher(_ref2) {
  var baseUrl = _ref2.baseUrl,
      ssoUrl = _ref2.ssoUrl,
      getRefreshToken = _ref2.getRefreshToken,
      getAccessToken = _ref2.getAccessToken,
      onRefresh = _ref2.onRefresh,
      requestDataTransformer = _ref2.requestDataTransformer,
      responseDataTransformer = _ref2.responseDataTransformer;
  var originalRefreshToken = getRefreshToken();
  var originalAccessToken = getAccessToken();

  var getNewAccessToken = function getNewAccessToken(oldRefreshToken) {
    return fetch("" + ssoUrl + oldRefreshToken).then(function (data) {
      return data.json();
    }).then(function (_ref3) {
      var refreshToken = _ref3.refreshToken,
          accessToken = _ref3.accessToken;
      onRefresh({
        accessToken: accessToken,
        refreshToken: refreshToken
      });
      return {
        refreshToken: refreshToken,
        accessToken: accessToken
      };
    });
  };

  var request = function request(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload, config) {
    if (config === void 0) {
      config = {};
    }

    try {
      var fetchConfig = _extends({}, config, {
        headers: _extends({
          'content-type': 'application/json'
        }, config.headers),
        method: method,
        body: payload ? JSON.stringify(requestDataTransformer ? requestDataTransformer(payload) : payload) : null
      });

      var getOriginalRequest = function getOriginalRequest(token) {
        return fetch("" + baseUrl + url, _extends({}, fetchConfig, {
          headers: _extends({}, token ? {
            Authorization: token
          } : {}, fetchConfig.headers)
        }));
      };

      if (isTokenRefreshing) return Promise.resolve(pushToFailedRequests(getOriginalRequest));
      return Promise.resolve(getOriginalRequest(originalAccessToken).then(function (res) {
        if (res.status === 419) {
          if (isTokenRefreshing) return pushToFailedRequests(getOriginalRequest);
          isTokenRefreshing = true;
          return getNewAccessToken(originalRefreshToken).then(function (_ref4) {
            var accessToken = _ref4.accessToken;

            try {
              /**
               * FIXME: Очень узкое место. Ждем, пока выполнится первый запрос, чтобы после этого
               * выполнить всю очередь. По каким-то причинам очередь не успевает заполнятся полностью,
               * если так не сделать.
               */
              return Promise.resolve(getOriginalRequest(accessToken)).then(function (newResponse) {
                processQueue(null, accessToken);
                return newResponse;
              });
            } catch (e) {
              return Promise.reject(e);
            }
          });
        }

        return res;
      })).then(function (response) {
        return response.ok ? getResponseBody(response, responseDataTransformer) : Promise.resolve(getResponseBody(response, responseDataTransformer)).then(function (errorData) {
          throw new NetworkError(response, errorData);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var getRequest = function getRequest(url, config) {
    return request(methods.GET, url, null, config);
  };

  var putRequest = function putRequest(url, payload, config) {
    return request(methods.PUT, url, payload, config);
  };

  var patchRequest = function patchRequest(url, payload, config) {
    return request(methods.PATCH, url, payload, config);
  };

  var postRequest = function postRequest(url, payload, config) {
    return request(methods.POST, url, payload, config);
  };

  var deleteRequest = function deleteRequest(url, config) {
    return request(methods.DELETE, url, null, config);
  };

  return {
    get: getRequest,
    put: putRequest,
    patch: patchRequest,
    post: postRequest,
    "delete": deleteRequest
  };
};

var cookieService = {
  set: function set() {
    return cookies.set.apply(cookies, arguments);
  },
  get: function get(name) {
    return cookies.get(name);
  },
  remove: function remove() {
    return cookies.remove.apply(cookies, arguments);
  }
};

var ACCESS_TOKEN = 'accessToken';
var REFRESH_TOKEN = 'refreshToken';
var LIFETIME_DAYS = 365; // FIXME: выяснить на какой ТОЧНО домен нужно сетить куки `qlean.ru` или `.qlean.ru`

var DOMAIN = '.qlean.ru';
var mainDomain = {
  domain: DOMAIN
};

var tokensConfig = /*#__PURE__*/_extends({
  expires: LIFETIME_DAYS
}, mainDomain);

var getAccessToken = function getAccessToken() {
  return cookieService.get(ACCESS_TOKEN);
};
var getRefreshToken = function getRefreshToken() {
  return cookieService.get(REFRESH_TOKEN);
};
var resetTokens = function resetTokens() {
  cookieService.remove(ACCESS_TOKEN, _extends({}, mainDomain));
  cookieService.remove(REFRESH_TOKEN, _extends({}, mainDomain)); // INFO: Лабс вешал куку на `qlean.ru` из-за этого они не сбрасывались при 403
  // Потому, удаляю и на `.qlean.ru` и на `qlean.ru`

  cookieService.remove(ACCESS_TOKEN, {
    domain: 'qlean.ru'
  });
  cookieService.remove(REFRESH_TOKEN, {
    domain: 'qlean.ru'
  });
}; // INFO: если что-то идет не так (например refresh уже умер), то york-fetcher возвращает undefined,
// и он строкой сетит этот undefined в куку
// Потому приходится проверять токен на его наличие, и если его нет, то ресетить

var setAccessToken = function setAccessToken(token) {
  if (token) {
    cookieService.set(ACCESS_TOKEN, token, tokensConfig);
  } else {
    resetTokens();
  }
};
var setRefreshToken = function setRefreshToken(token) {
  if (token) {
    cookieService.set(REFRESH_TOKEN, token, tokensConfig);
  } else {
    resetTokens();
  }
};

var fetcherOptions = {
  getAccessToken: getAccessToken,
  getRefreshToken: getRefreshToken,
  onRefresh: function onRefresh(_ref) {
    var accessToken = _ref.accessToken,
        refreshToken = _ref.refreshToken;
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
  }
}; // Обертка для фетчера (адаптирует axios api под york-fetch)

var fetcherWrap = function fetcherWrap(options) {
  try {
    var method = options.method,
        url = options.url,
        data = options.data,
        params = options.params,
        baseUrl = options.baseUrl,
        ssoUrl = options.ssoUrl;
    var urlWithParams = url; // нативный fetch не умеет работать с квери параметрами (???)
    // если они есть, то конвертим их в строку, и конкатенатим к урлу

    if (params) {
      var queryString = Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join('&');

      if (queryString) {
        urlWithParams += "?" + queryString;
      }
    }

    var casedMethod = method.toLowerCase(); // чтобы фетчер подхватил куки после их установки, приходится пересоздавать на каждом запросе

    var fetcherInstance = fetcher(_extends({
      baseUrl: baseUrl,
      ssoUrl: ssoUrl
    }, fetcherOptions)); // если это GET или DELETE, то он принимает config вторым аргументом, иначе третьим

    if (casedMethod === 'get' || casedMethod === 'delete') {
      var _instance = fetcherInstance[casedMethod](urlWithParams);

      return Promise.resolve(_instance);
    }

    var instance = fetcherInstance[casedMethod](urlWithParams, data);
    return Promise.resolve(instance);
  } catch (e) {
    return Promise.reject(e);
  }
};

var fetcherWithAuth = function fetcherWithAuth(options) {
  try {
    return Promise.resolve(fetcherWrap(options)["catch"](Promise.reject));
  } catch (e) {
    return Promise.reject(e);
  }
};

function trackAnalyticEvent(event) {
  var _window$dataLayer;

  (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push(event);
}

var log = function log(msg, payload) {
  if (process.env.NODE_ENV === 'development') {
    console.log("\uD83D\uDE8E " + msg, payload);
  }
};

function emit(eventName, detail) {
  var event = new CustomEvent(eventName, {
    detail: detail
  });
  log(eventName + " :", detail || 'no payload');
  window.document.dispatchEvent(event);
}

function on(eventName, callback) {
  var listener = function listener(evt) {
    if (!(evt instanceof CustomEvent)) {
      throw new TypeError("Unknown type of event " + eventName + ": " + evt);
    }

    callback(evt.detail);
  };

  window.document.addEventListener(eventName, listener);
  log("subscribe on " + eventName);
  return function () {
    window.document.removeEventListener(eventName, listener);
    log("Unsubscribe from " + eventName);
  };
}

var Bus = {
  emit: emit,
  on: on
};

var USER_LOGIN_REQUEST = '__QLEAN_BUS_EVENT/USER_LOGIN_REQUEST';
var USER_LOGIN_SUCCESS = '__QLEAN_BUS_EVENT/USER_LOGIN_SUCCESS';
var USER_LOGOUT_REQUEST = '__QLEAN_BUS_EVENT/USER_LOGOUT_REQUEST';
var USER_LOGOUT_SUCCESS = '__QLEAN_BUS_EVENT/USER_LOGOUT_SUCCESS';
var REGION_CHANGE = '__QLEAN_BUS_EVENT/REGION_CHANGE';
var TOOLTIP_SHOW_REQUEST = '__QLEAN_BUS_EVENT/TOOLTIP_SHOW_REQUEST';
var PERMANENT_NOTIFICATION_SHOW_REQUEST = '__QLEAN_BUS_EVENT/PERMANENT_NOTIFICATION_SHOW_REQUEST';
var PERMANENT_NOTIFICATION_HIDE_REQUEST = '__QLEAN_BUS_EVENT/PERMANENT_NOTIFICATION_HIDE_REQUEST';
var TRACK_ANALYTIC_EVENT = '__QLEAN_BUS_EVENT/TRACK_ANALYTIC_EVENT';
var WIDGET_MOUNTED = '__QLEAN_BUS_EVENT/WIDGET_MOUNTED';

function getScripts(list) {
  return list.map(function (item) {
    return "<script type=\"application/ld+json\">" + JSON.stringify(item) + "</script>";
  });
}
function getProduct(_ref, context) {
  var url = _ref.url,
      title = _ref.title,
      description = _ref.description,
      offers = _ref.offers,
      aggregateRating = _ref.aggregateRating,
      review = _ref.review;

  if (context === void 0) {
    context = 'https://schema.org';
  }

  return {
    '@context': context,
    '@type': 'Product',
    url: url,
    name: title,
    description: description,
    offers: offers,
    aggregateRating: aggregateRating,
    review: review
  };
}
function getFAQ(data, context) {
  if (context === void 0) {
    context = 'https://schema.org';
  }

  return {
    '@context': context,
    '@type': 'FAQPage',
    mainEntity: data.map(function (_ref2) {
      var question = _ref2.question,
          answer = _ref2.answer;
      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: [{
          '@type': 'Answer',
          text: answer
        }]
      };
    })
  };
}
function getHowTo(_ref3, context) {
  var title = _ref3.title,
      steps = _ref3.steps;

  if (context === void 0) {
    context = 'https://schema.org';
  }

  return {
    '@context': context,
    '@type': 'HowTo',
    name: title,
    step: steps.map(function (_ref4) {
      var caption = _ref4.caption,
          description = _ref4.description;
      return {
        '@type': 'HowToStep',
        name: caption,
        text: description
      };
    })
  };
}
function getOffers(_ref5) {
  var prices = _ref5.prices,
      currency = _ref5.currency;
  return {
    '@type': 'AggregateOffer',
    priceCurrency: currency,
    lowPrice: Math.min.apply(Math, prices),
    offerCount: prices.length
  };
}

function getRating(_ref6) {
  var rating = _ref6.rating,
      bestRating = _ref6.bestRating,
      worstRating = _ref6.worstRating;
  return {
    '@type': 'Rating',
    ratingValue: rating,
    bestRating: bestRating,
    worstRating: worstRating
  };
}

function getPerson(name) {
  return {
    '@type': 'Person',
    name: name
  };
}

function getReview(data) {
  return data.map(function (_ref7) {
    var text = _ref7.text,
        author = _ref7.author,
        rating = _objectWithoutPropertiesLoose(_ref7, ["text", "author"]);

    return {
      '@type': 'Review',
      reviewBody: text,
      reviewRating: getRating(rating),
      author: getPerson(author)
    };
  });
}
function getAggregateRating(_ref8) {
  var ratingCount = _ref8.ratingCount,
      reviewCount = _ref8.reviewCount,
      ratingParams = _objectWithoutPropertiesLoose(_ref8, ["ratingCount", "reviewCount"]);

  var _getRating = getRating(ratingParams),
      rating = _objectWithoutPropertiesLoose(_getRating, ["@type"]);

  return _extends({
    '@type': 'AggregateRating',
    ratingCount: ratingCount,
    reviewCount: reviewCount
  }, rating);
}

var formatPhone = function formatPhone(phone) {
  var strPhone = phone.toString();
  return strPhone.replace(/\D/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, (strPhone.startsWith('8') ? '' : '+') + "$1\xA0($2)\xA0$3\u2011$4\u2011$5" // неразрывный дефис "‑"
  );
};
var formatPhoneHref = function formatPhoneHref(phone) {
  var strPhone = phone.toString();
  return "tel:" + (strPhone.startsWith('8') ? '' : '+') + strPhone.replace(/\D/g, '');
};
function pluralize(_ref, amount) {
  var form1 = _ref[0],
      form2 = _ref[1],
      form5 = _ref[2];
  var compareValue = Math.abs(amount % 100);
  compareValue = compareValue > 20 ? compareValue % 10 : compareValue;

  if (compareValue === 1) {
    return form1;
  } else if (compareValue > 1 && compareValue < 5) {
    return form2;
  }

  return form5;
}

function getCapitalized(value) {
  var str = value.toString();
  return "" + str.slice(0, 1).toUpperCase() + str.slice(1);
}

function getFromMocks(_ref2) {
  var _pageData$, _promoData$, _regionData$;

  var mocks = _ref2.mocks,
      domain = _ref2.domain,
      pageSlug = _ref2.pageSlug,
      region = _ref2.region,
      _ref2$promo = _ref2.promo,
      promo = _ref2$promo === void 0 ? '' : _ref2$promo,
      _ref2$unitKey = _ref2.unitKey,
      unitKey = _ref2$unitKey === void 0 ? '' : _ref2$unitKey;
  var pageData = mocks[domain][pageSlug];
  var promoData = (_pageData$ = pageData["promo" + getCapitalized(promo)]) !== null && _pageData$ !== void 0 ? _pageData$ : pageData.promoCommon;
  var regionData = (_promoData$ = promoData["region" + getCapitalized(region)]) !== null && _promoData$ !== void 0 ? _promoData$ : promoData.regionCommon;
  return (_regionData$ = regionData["unit" + getCapitalized(unitKey)]) !== null && _regionData$ !== void 0 ? _regionData$ : regionData.unitCommon;
}

export { Bus, PERMANENT_NOTIFICATION_HIDE_REQUEST, PERMANENT_NOTIFICATION_SHOW_REQUEST, REGION_CHANGE, TOOLTIP_SHOW_REQUEST, TRACK_ANALYTIC_EVENT, USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGOUT_REQUEST, USER_LOGOUT_SUCCESS, WIDGET_MOUNTED, cookieService, fetcherPure, fetcherWithAuth, formatPhone, formatPhoneHref, getAggregateRating, getFAQ, getFromMocks, getHowTo, getOffers, getProduct, getReview, getScripts, pluralize, trackAnalyticEvent };
//# sourceMappingURL=web-core.esm.js.map
